module.exports = __webpack_public_path__ + "media/images/svgs/admin/team-f07457eacfb2804305a967967d1552a1.svg";